// This file extends the existing SEO implementation to add support for external Shopify storefronts

import type { PaginationSEOLink } from 'types/seo'
import { EXTERNAL_SHOPIFY_REDIRECTS } from '../server/utils/external-storefronts'

/**
 * Generates hreflang entries for external Shopify storefronts (AU/NZ)
 *
 * @returns Array of hreflang entries for external Shopify storefronts
 */
export function generateExternalShopifyHreflangs(): PaginationSEOLink[] {
  // Generate hreflang entries for external Shopify storefronts
  const externalHreflangs: PaginationSEOLink[] = []

  // Add AU hreflang entry
  if (EXTERNAL_SHOPIFY_REDIRECTS.AU) {
    externalHreflangs.push({
      hid: `alternate:${EXTERNAL_SHOPIFY_REDIRECTS.AU.hreflang}`,
      rel: 'alternate',
      hrefLang: EXTERNAL_SHOPIFY_REDIRECTS.AU.hreflang,
      href: EXTERNAL_SHOPIFY_REDIRECTS.AU.target,
    })
  }

  // Add NZ hreflang entry
  if (EXTERNAL_SHOPIFY_REDIRECTS.NZ) {
    externalHreflangs.push({
      hid: `alternate:${EXTERNAL_SHOPIFY_REDIRECTS.NZ.hreflang}`,
      rel: 'alternate',
      hrefLang: EXTERNAL_SHOPIFY_REDIRECTS.NZ.hreflang,
      href: EXTERNAL_SHOPIFY_REDIRECTS.NZ.target,
    })
  }

  return externalHreflangs
}
